import { version as ReactVersion } from 'react';
import type { FunctionComponentElement, ReactNode } from 'react';

import { logError } from './log';

export const legacyReactMessage = 'React-dom/client cannot be imported, using legacy render.';

export async function renderRootElement(rootElement: HTMLElement, children: ReactNode) {
  if (ReactVersion.startsWith('18')) {
    const { createRoot } = await import('react-dom/client');
    createRoot(rootElement).render(children);
  } else {
    if (process.env.NODE_ENV !== 'production') {
      logError(legacyReactMessage);
    }
    const { render: reactDomRender } = await import('react-dom');
    reactDomRender(children as FunctionComponentElement<unknown>, rootElement);
  }
}
